module.exports = __webpack_public_path__ + "static/media/ankitvaria.f33117f0.jpeg";